import { render, staticRenderFns } from "./spinner-winnings.vue?vue&type=template&id=a572acfa&scoped=true&"
import script from "./spinner-winnings.vue?vue&type=script&lang=js&"
export * from "./spinner-winnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a572acfa",
  null
  
)

export default component.exports